var map = {
	"./books.svg": "8bd5",
	"./books2.svg": "2a6b",
	"./calendar-check.svg": "2831",
	"./check-circle.svg": "cfcb",
	"./checklist.svg": "f589",
	"./chevron-down.svg": "1755",
	"./download.svg": "f28e",
	"./eye.svg": "7364",
	"./file-pdf.svg": "d890",
	"./file-pdf2.svg": "74c0",
	"./id-card.svg": "9f10",
	"./kebijakan-kepmen.svg": "294a",
	"./kebijakan-lainnya.svg": "f91d",
	"./kebijakan-permen.svg": "5581",
	"./kebijakan-pp.svg": "966d",
	"./kebijakan-semua.svg": "765b",
	"./kebijakan-sk.svg": "64b9",
	"./kebijakan-undang-undang.svg": "82f2",
	"./laptop.svg": "cd06",
	"./list-check.svg": "672d",
	"./map-pin.svg": "60c5",
	"./note.svg": "f079",
	"./paper-dashed.svg": "7a20",
	"./paper.svg": "5fef",
	"./pen.svg": "6492",
	"./pencil-blue.svg": "67cb",
	"./pencil.svg": "e51f",
	"./printer.svg": "345d",
	"./seal-check.svg": "7c89",
	"./trash.svg": "af22",
	"./user-three.svg": "73e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";